import { Button, ButtonRow, Checkbox } from '@timelyapp/react';
import SuperModal, { ModalContent, ModalHeader, ModalHeaderGroup } from 'components/modals';
import React, { useEffect, useState } from 'react';
import styles from './MoveToArchivedWarningModal.module.scss';

interface Props {
  isOpen: boolean;
  onConfirm: (dontShowAgain: boolean) => void;
  onCancel: () => void;
}

const MoveToArchivedWarningModal: React.FC<Props> = ({ isOpen, onConfirm, onCancel }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setDontShowAgain(false);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm(dontShowAgain);
  };

  return (
    <SuperModal
      isOpen={isOpen}
      shouldFocusAfterRender
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onClose={onCancel}
    >
      <div className={styles.container}>
        <ModalHeader>
          <ModalHeaderGroup autoGrow title>
            Move to Archived Project
          </ModalHeaderGroup>
        </ModalHeader>
        <ModalContent>
          <p>You are moving time to an archived project.</p>
          <p className={styles.note}>
            Any tag selections will be cleared to avoid validation conflicts.
          </p>
          <div className={styles.checkbox}>
            <Checkbox
              checked={dontShowAgain}
              onChangeChecked={setDontShowAgain}
              label="Don't show this again"
            />
          </div>
          <ButtonRow className={styles.buttons}>
            <Button priority="medium" onClick={onCancel}>
              Cancel
            </Button>
            <Button priority="xhigh" onClick={handleConfirm}>
              Confirm
            </Button>
          </ButtonRow>
        </ModalContent>
      </div>
    </SuperModal>
  );
};

export default MoveToArchivedWarningModal;
